/* Navbar react component with customizable menu and css class
 *
 * Only two level deep menus are supported
 */

import React, { Component } from 'react'
import { slide as Burger } from 'react-burger-menu'
import { Location } from '@reach/router'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { Link } from 'gatsby'
import { StaticQuery, graphql } from 'gatsby'

class DropdownMenu extends Component {
  constructor() {
    super()
    this.state = { hover: false }
    this.handleMouseOver = this.handleMouseOver.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
  }

  handleMouseOver() {
    this.setState({ hover: true })
  }

  handleMouseLeave() {
    this.setState({ hover: false })
  }

  render() {
    return (
      <li
        className={'dropdown' + (this.state.hover ? ' active' : '')}
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
      >
        {this.props.children}
      </li>
    )
  }
}

const NavItem = props => (
  <li>
    <Link to={props.to} activeClassName="active">
      {props.text}
    </Link>
  </li>
)

NavItem.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

const translate = {
  zh: '/en/',
  en: '/zh/',
}

const LangButton = props => (
  // Only works when built with --prefix-paths
  <Location>
    {lprops => (
      <div className="header__lang">
        <a
          href={
            translate[props.lang] +
            lprops.location.pathname
              .split('/')
              .slice(2)
              .join('/')
          }
          style={{
            textDecoration: 'none',
          }}
        >
          繁／En
        </a>
      </div>
    )}
  </Location>
)

const MENU = {
  zh: [
    { to: '/how-it-works', text: '如何運作' },
    { to: '/security', text: '數據安全' },
    { to: '/features', text: '產品特點' },
    { to: '/faq', text: '常見問題' },
    { to: 'https://blog.gini.co/blog', text: 'Blog', extern: true },
    {
      text: '關於我們',
      menu: [
        { to: '/our-story', text: '品牌故事' },
        // { to: '/contact-us', text: '聯絡我們' },
      ],
    },
  ],
  en: [
    { to: '/how-it-works', text: 'How it works' },
    { to: '/security', text: 'Security' },
    { to: '/features', text: 'Features' },
    { to: '/faq', text: 'FAQ' },
    { to: 'https://blog.gini.co/blog', text: 'Blog', extern: true },
    {
      text: 'About Us',
      menu: [
        { to: '/our-story', text: 'Our Story' },
        // { to: '/contact-us', text: 'Contact Us' },
      ],
    },
  ],
}

const Navbar = ({ extra_class, logo, menu }) => {
  return (
    <StaticQuery
      query={graphql`
        {
          site {
            siteMetadata {
              lang
            }
          }
        }
      `}
      render={props => {
        const lang = props.site.siteMetadata.lang
        //const path = props.page.pathname

        // magic happens, yes there can be a more readable implementation but w/e
        // fallback to default menus defined by languages
        const nav_items = _.map(menu ? menu : MENU[lang], (item, idx) => {
          if (item.extern != null) {
            return (
              <li key={idx}>
                <a href={item.to}>{item.text}</a>
              </li>
            )
          } else if (item.to != null) {
            return <NavItem to={item.to} text={item.text} key={idx} />
          } else {
            return (
              <DropdownMenu key={idx}>
                <button>{item.text}</button>
                <ul className="dropdown__content" key={idx * 100 + 1}>
                  {_.map(item.menu, (subitem, jdx) => (
                    <NavItem
                      to={subitem.to}
                      text={subitem.text}
                      key={jdx * 1000}
                    />
                  ))}
                </ul>
              </DropdownMenu>
            )
          }
        })

        return (
          <>
            <header
              className={
                extra_class ? 'header'.concat(' ', extra_class) : 'header'
              }
            >
              <div className="header__inner">
                <div className="header__logotype">
                  <Link to="/">
                    <img src={logo ? logo : '/img/logo.svg'} alt="Gini" />
                  </Link>
                </div>

                <ul className="header__nav">{nav_items}</ul>
                <LangButton lang={lang} />
              </div>
            </header>
            <Burger
              right
              width={200}
              styles={{
                bmBurgerButton: {
                  zIndex: 10000,
                  position: 'fixed',
                },
                bmBurgerBars: {
                  background: extra_class ? '#efefef' : '#47217f',
                  borderRadius: '2px',
                },
                bmMenuWrap: {
                  background: '#efefef',
                  zIndex: 10001,
                },
                bmMenu: {
                  zIndex: 10001,
                },
                bmOverlay: {
                  zIndex: 10000,
                },
              }}
            >
              {nav_items}
            </Burger>
            {/* Styles are found in quick.css */}
          </>
        )
      }}
    />
  )
}

export default Navbar
